export default __webpack_public_path__ + "static/media/dollar-dash.d3d4c25e.svg";